<template>
  <span class="look-more" @click="lookMore">
    查看更多
    <i class="el-icon-arrow-right"></i>
  </span>
</template>
<script>
export default {
  name: "look-more",
  props: {
    type: String
  },

  data: function() {
    return {
      
    };
  },

  methods: {
    lookMore() {
      this.$router.push({
        name: "result-more",
        params: { key: this.$route.params.key, type: this.type }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.look-more {
  line-height: 40px;
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  margin-left: auto;
  font-weight: normal;
  vertical-align: middle;
  float: right;
  cursor: pointer;

  .el-icon-arrow-right {
    margin-left: 5px;
    vertical-align: middle;
  }
}
</style>
